import React, { useEffect } from 'react';

import MarketingHeader from '../components/MarketingHeader';
import '../styles/MarketingTheme.css';



const PrivacyPolicyPage = () => {


    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="marketing-page stunning-theme">
            <MarketingHeader />

            {/* Main Content */}
            <div className="marketing-container mt-4 mb-lg">
                <div className="legal-layout">
                    {/* Sidebar Navigation */}
                    <aside className="marketing-legal-sidebar hidden md:block">
                        <div className="mb-4">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">On this page</p>
                            <nav className="flex flex-col space-y-2">
                                <button onClick={() => scrollToSection('collect')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">1. Information Collection</button>
                                <button onClick={() => scrollToSection('use')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">2. Usage of Data</button>
                                <button onClick={() => scrollToSection('share')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">3. Data Sharing</button>
                                <button onClick={() => scrollToSection('security')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">4. Security Measures</button>
                                <button onClick={() => scrollToSection('contact')} className="text-left text-gray-400 hover:text-white transition-colors text-sm py-1">5. Contact Us</button>
                            </nav>
                        </div>
                        <div className="mt-8 pt-6 border-t border-white/10">
                            <p className="text-xs text-gray-500 mb-2">Have questions?</p>
                            <a href="mailto:support@redsorm.in" className="text-sm text-purple-400 hover:text-purple-300 font-medium">Contact Support →</a>
                        </div>
                    </aside>

                    {/* Document Content */}
                    <article className="marketing-legal-content">
                        <div className="flex items-center gap-2 mb-8">
                            <span className="w-2 h-2 rounded-full bg-green-500"></span>
                            <span className="text-sm text-gray-400">Last updated: {new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                        </div>

                        <h1>Privacy Policy</h1>
                        <p className="lead text-lg text-gray-300 mb-10 border-b border-white/10 pb-8">
                            We believe that your data belongs to you. This policy outlines how we collect, process, and protect your information when you use the RedSorm platform.
                        </p>

                        <div id="collect" className="mb-12">
                            <h2>1. Information We Collect</h2>
                            <p>To provide you with our world-class restaurant management services, we need to collect specific data points. We believe in transparency and only collect what is necessary.</p>

                            <div className="grid md:grid-cols-2 gap-4 mt-6">
                                <div className="marketing-card p-4 bg-white/5 border-none">
                                    <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-400 mb-4">
                                        <i className="fas fa-user"></i>
                                    </div>
                                    <h3 className="text-lg font-bold text-white mb-2">Account Data</h3>
                                    <p className="text-sm text-gray-400">Basic details like name, email, and phone number to verify your identity.</p>
                                </div>
                                <div className="marketing-card p-4 bg-white/5 border-none">
                                    <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center text-purple-400 mb-4">
                                        <i className="fas fa-store"></i>
                                    </div>
                                    <h3 className="text-lg font-bold text-white mb-2">Business Data</h3>
                                    <p className="text-sm text-gray-400">Menu items, inventory logs, and operational settings for your dashboard.</p>
                                </div>
                            </div>
                        </div>

                        <div id="use" className="mb-12">
                            <h2>2. How We Use Your Data</h2>
                            <p>We use your information to operate, maintain, and improve our services. Specifically, we use it for:</p>
                            <ul className="list-disc pl-5 space-y-2 text-gray-400 mb-6">
                                <li>Provisioning your unique restaurant dashboard instance.</li>
                                <li>Processing secure operational transactions.</li>
                                <li>Training our AI models to provide better inventory predictions (anonymized).</li>
                                <li>Sending critical alerts regarding system status or security.</li>
                            </ul>
                        </div>

                        <div id="share" className="mb-12">
                            <h2>3. Data Sharing & Disclosure</h2>
                            <p>We do not sell your personal data. We only share information with third parties when it is essential for the service, such as:</p>
                            <p className="mt-4"><strong className="text-white">Cloud Infrastructure:</strong> We use AWS and Google Cloud to securely host your data.</p>
                            <p><strong className="text-white">Payment Processing:</strong> Payment details are handled securely by Stripe/Razorpay; we do not store full credit card numbers.</p>
                        </div>

                        <div id="security" className="mb-12">
                            <h2>4. Security Measures</h2>
                            <p>Security is core to our engineering culture. We employ AES-256 encryption at rest and TLS 1.3 for data in transit. Access to your production data is strictly limited to authorized engineers for debugging purposes only.</p>
                        </div>

                        <div id="contact" className="mt-12 pt-8 border-t border-white/10">
                            <h2>5. Contact Us</h2>
                            <p>If you have any questions about this policy or your data rights, please reach out to our Data Protection Officer.</p>
                            <a href="mailto:support@redsorm.in" className="inline-flex items-center gap-2 text-purple-400 font-semibold hover:text-purple-300 transition-colors mt-4">
                                <i className="fas fa-envelope"></i> support@redsorm.in
                            </a>
                        </div>
                    </article>
                </div>
            </div>

            {/* Footer */}
            <footer className="marketing-footer">
                <div className="marketing-footer-content">
                    <p>&copy; {new Date().getFullYear()} RedSorm. All rights reserved.</p>
                    <div className="marketing-footer-links">
                        <a href="/terms-of-service" className="marketing-footer-link">Terms</a>
                        <a href="/privacy-policy" className="marketing-footer-link">Privacy</a>
                        <a href="/cookie-policy" className="marketing-footer-link">Cookies</a>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default PrivacyPolicyPage;
